/**
 * Route for `free-trial-first-10-000-conversions-free-30-days`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FreeTrialFirst10000ConversionsFree30DaysPage } from "../features/free-trial-first-10-000-conversions-free-30-days/FreeTrialFirst10000ConversionsFree30DaysPage";

export const freeTrialFirst10000ConversionsFree30DaysRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/free-trial-first-10-000-conversions-free-30-days",
	component: FreeTrialFirst10000ConversionsFree30DaysPage,
});

export default freeTrialFirst10000ConversionsFree30DaysRoute;
